/**
 * CATALOG HEADER COMPONENT
 * 
 * Header for product catalog with title and tier filter
 */

import React from 'react';
import { TIER_LABELS } from '../../hooks/useProductCatalog';

const CatalogHeader = ({ fixture, activeTier, onTierFilter }) => {
  const tiers = ['all', 'builder', 'mid', 'premium'];
  
  return (
    <div className="catalog-header">
      <div className="catalog-title">
        <h2>{fixture?.fixture_label || 'Select a fixture'}</h2>
        {fixture && (
          <span className="catalog-subtitle">
            for {fixture.area_label}
          </span>
        )}
      </div>
      
      {fixture && (
        <div className="tier-filter">
          <span className="tier-label">Show:</span>
          {tiers.map(tier => (
            <button
              key={tier}
              className={`tier-btn ${tier !== 'all' ? `tier-${tier}` : ''} ${activeTier === tier ? 'active' : ''}`}
              onClick={() => onTierFilter(tier)}
            >
              {tier === 'all' ? 'All' : TIER_LABELS[tier]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CatalogHeader;
